/* ══════════════════════════════════════════════════════════════════════
   ce-page-builder.js
   Dedicated Javascript Engine for Custom Embroidery Page Builder (Hats & Caps)
   Updated: Exact same card logic as Custom T-Shirt page (variant rows, dropdown selects, out of stock checks, multi-variant addition), plus Global Embroidery Style (Flat vs 3D Puff), Placement, and Thread Colors.
   ══════════════════════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function() {
  const builderEl = document.querySelector('.ce-builder');
  if (!builderEl) return;

  async function loadHtml2Canvas() {
    if (window.html2canvas) return window.html2canvas;
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
      script.onload = () => resolve(window.html2canvas);
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  // --- LOGO BYPASS LOGIC ---
  const bypassRadios = document.querySelectorAll('input[name="ce_logo_bypass"]');
  const uploadMainContainer = document.getElementById('ce-upload-container-main');
  bypassRadios.forEach(radio => {
    radio.addEventListener('change', (e) => {
      if (e.target.value === 'upload') {
        if (uploadMainContainer) uploadMainContainer.style.display = 'block';
      } else {
        if (uploadMainContainer) uploadMainContainer.style.display = 'none';
      }
      buildOrderSummary();
    });
  });
  // -------------------------

  const setupFeeId = builderEl.getAttribute('data-setup-fee-id') || '';
  const setupFeePrice = parseFloat(builderEl.getAttribute('data-setup-fee-price') || '34.99');
  const embroideryFeeId = builderEl.getAttribute('data-embroidery-fee-id') || '';
  const embroideryFeePrice = parseFloat(builderEl.getAttribute('data-embroidery-fee-price') || '15.99');
  const customerId = builderEl.getAttribute('data-customer-id') || '';

  const addLocFeeId = builderEl.getAttribute('data-add-loc-fee-id') || '';
  const addLocTiersStr = builderEl.getAttribute('data-add-loc-tiers') || '1:10.00';
  let ADD_LOC_TIERS = [];
  try {
    const parts = addLocTiersStr.split(',').map(s => s.trim());
    parts.forEach(p => {
      const [qtyStr, priceStr] = p.split(':');
      if (qtyStr && priceStr) {
        ADD_LOC_TIERS.push({ min: parseInt(qtyStr, 10), price: parseFloat(priceStr), tier: parseInt(qtyStr, 10) });
      }
    });
    ADD_LOC_TIERS.sort((a, b) => b.min - a.min); // Sort descending
  } catch(e) { console.error('Failed to parse additional location tiers'); }

  function getAddLocTierPrice(qty) {
    if (qty <= 0) return 0;
    if (ADD_LOC_TIERS.length === 0) return 10.00;
    for (let i = 0; i < ADD_LOC_TIERS.length; i++) {
      if (qty >= ADD_LOC_TIERS[i].min) return ADD_LOC_TIERS[i].price;
    }
    return ADD_LOC_TIERS[ADD_LOC_TIERS.length - 1].price;
  }

  // State
  let activePlacement = 'Left Panel';
  let activeDesignUrl = '';
  let activeDesignName = '';
  let activeDesignType = 'new'; // 'new' or 'saved'
  let activeDesignIsHighDpi = false;
  let selectedThreadColors = [];
  let activeEmbStyle = 'Flat Embroidery';
  const placementState = {
    'Left Panel': { x: 0, y: 0, scale: 1.0, rotate: 0 },
    'Centered': { x: 0, y: 0, scale: 1.0, rotate: 0 },
    'Right Panel': { x: 0, y: 0, scale: 1.0, rotate: 0 },
    'Back': { x: 0, y: 0, scale: 1.0, rotate: 0 },
    'Left Side': { x: 0, y: 0, scale: 1.0, rotate: 0 },
    'Right Side': { x: 0, y: 0, scale: 1.0, rotate: 0 }
  };

  // New pricing: use actual product price with flat 10% off when total qty >= 20
  function getTierPrice(totalQty, productPrice) {
    const price = productPrice || 0;
    if (totalQty >= 20) return price * 0.90;
    return price;
  }

  /* ── 1. Store Product Card Variant Data ── */
  const productCards = Array.from(builderEl.querySelectorAll('.ce-product-card'));
  const cardDataMap = new Map();

  productCards.forEach(card => {
    const pid = card.dataset.productId;
    const jsonEl = card.querySelector('.ce-product-json');
    let variants = [];
    if (jsonEl) {
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { console.warn('JSON error card ' + pid, e); }
    }
    cardDataMap.set(pid, {
      id: pid,
      title: card.dataset.productTitle || '',
      basePrice: parseFloat(card.dataset.basePrice || 0),
      variants: variants
    });
  });

  function getRowVariant(cardEl, rowEl) {
    const pid = cardEl.dataset.productId;
    const data = cardDataMap.get(pid);
    if (!data || !data.variants || data.variants.length === 0) return null;

    if (data.variants.length === 1) return data.variants[0];

    const selects = Array.from(rowEl.querySelectorAll('.ce-variant-select'));
    if (selects.length === 0) return data.variants.find(v => v.available) || data.variants[0];

    const chosen = selects.map(s => s.value);
    const exactMatch = data.variants.find(v => {
      return chosen.every((val, idx) => v.options[idx] === val);
    });
    return exactMatch || data.variants.find(v => v.available) || data.variants[0];
  }

  function preselectFirstAvailable(cardEl, rowEl) {
    const pid = cardEl.dataset.productId;
    const data = cardDataMap.get(pid);
    if (!data || !data.variants || data.variants.length === 0) return;

    const firstAvail = data.variants.find(v => v.available);
    if (!firstAvail) return;

    const selects = Array.from(rowEl.querySelectorAll('.ce-variant-select'));
    if (selects.length > 0 && firstAvail.options) {
      selects.forEach((sel, idx) => {
        if (firstAvail.options[idx] !== undefined) {
          sel.value = firstAvail.options[idx];
        }
      });
    }
  }

  function getCardTotalQty(cardEl) {
    const inputs = Array.from(cardEl.querySelectorAll('.ce-qty-input'));
    return inputs.reduce((sum, inp) => sum + (parseInt(inp.value, 10) || 0), 0);
  }

  function checkCardSelectionState(cardEl) {
    const checkbox = cardEl.querySelector('.ce-card-checkbox');
    const totalQty = getCardTotalQty(cardEl);

    if (totalQty > 0) {
      if (checkbox) checkbox.checked = true;
      cardEl.classList.add('ce-card--selected');
    } else {
      if (checkbox) checkbox.checked = false;
      cardEl.classList.remove('ce-card--selected');
    }
    updateGlobalBulkInfo();
    buildOrderSummary();
    if (typeof updateMultiPlacementContainer === 'function') updateMultiPlacementContainer();
  }

  function updateRowVariantImageAndPrice(cardEl, rowEl) {
    const variant = getRowVariant(cardEl, rowEl);
    const errorEl = rowEl.querySelector('.ce-variant-error');
    const qtyInput = rowEl.querySelector('.ce-qty-input');
    const imgEl = cardEl.querySelector('.ce-card-image');

    if (variant) {
      if (!variant.available) {
        if (errorEl) {
          errorEl.textContent = 'Out of stock';
          errorEl.style.display = 'block';
        }
        if (qtyInput) qtyInput.value = '0';
      } else {
        if (errorEl) errorEl.style.display = 'none';
      }

      if (variant.featured_image && variant.featured_image.src && imgEl && imgEl.tagName === 'IMG') {
        imgEl.src = variant.featured_image.src;
      } else if (cardEl.dataset.featuredImage && imgEl && imgEl.tagName === 'IMG') {
        imgEl.src = cardEl.dataset.featuredImage;
      }
    }
  }

  function setupRowListeners(cardEl, rowEl, isInitialLoad = false) {
    if (isInitialLoad) {
      preselectFirstAvailable(cardEl, rowEl);
    }

    const selects = Array.from(rowEl.querySelectorAll('.ce-variant-select'));
    selects.forEach(sel => {
      sel.addEventListener('change', () => {
        updateRowVariantImageAndPrice(cardEl, rowEl);
        checkCardSelectionState(cardEl);
      });
    });

    const minusBtn = rowEl.querySelector('.ce-qty-minus');
    const plusBtn = rowEl.querySelector('.ce-qty-plus');
    const qtyInput = rowEl.querySelector('.ce-qty-input');

    if (minusBtn && qtyInput) {
      minusBtn.addEventListener('click', () => {
        let val = parseInt(qtyInput.value || '0', 10);
        if (val > 0) {
          qtyInput.value = val - 1;
          checkCardSelectionState(cardEl);
        }
      });
    }

    if (plusBtn && qtyInput) {
      plusBtn.addEventListener('click', () => {
        const variant = getRowVariant(cardEl, rowEl);
        if (variant && !variant.available) {
          const errorEl = rowEl.querySelector('.ce-variant-error');
          if (errorEl) {
            errorEl.textContent = 'Variant out of stock';
            errorEl.style.display = 'block';
          }
          return;
        }
        let val = parseInt(qtyInput.value || '0', 10);
        qtyInput.value = val + 1;
        checkCardSelectionState(cardEl);
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('input', () => {
        let val = parseInt(qtyInput.value || '0', 10);
        if (isNaN(val) || val < 0) qtyInput.value = 0;
        checkCardSelectionState(cardEl);
      });
    }

    updateRowVariantImageAndPrice(cardEl, rowEl);
  }

  productCards.forEach(cardEl => {
    const checkbox = cardEl.querySelector('.ce-card-checkbox');
    if (checkbox) {
      checkbox.addEventListener('change', () => {
        if (checkbox.checked) {
          cardEl.classList.add('ce-card--selected');
          if (getCardTotalQty(cardEl) === 0) {
            const firstInp = cardEl.querySelector('.ce-qty-input');
            const firstRow = cardEl.querySelector('.ce-variant-row');
            const varObj = firstRow ? getRowVariant(cardEl, firstRow) : null;
            if (!varObj || varObj.available) {
              if (firstInp) firstInp.value = '1';
            }
          }
        } else {
          cardEl.classList.remove('ce-card--selected');
          cardEl.querySelectorAll('.ce-qty-input').forEach(inp => inp.value = '0');
        }
        checkCardSelectionState(cardEl);
      });
    }

    const initialRow = cardEl.querySelector('.ce-variant-row');
    if (initialRow) {
      setupRowListeners(cardEl, initialRow, true);
    }

    const addBtn = cardEl.querySelector('.ce-add-variant-btn');
    if (addBtn) {
      addBtn.addEventListener('click', () => {
        const container = cardEl.querySelector('.ce-card-variants-container');
        if (!container) return;

        const rows = container.querySelectorAll('.ce-variant-row');
        const firstRow = rows[0];
        if (!firstRow) return;

        const clone = firstRow.cloneNode(true);
        const rowId = rows.length;
        clone.dataset.rowId = rowId;

        const cloneInp = clone.querySelector('.ce-qty-input');
        if (cloneInp) cloneInp.value = '0';

        const cloneErr = clone.querySelector('.ce-variant-error');
        if (cloneErr) cloneErr.style.display = 'none';

        if (rows.length === 1) {
          const delBtn0 = document.createElement('button');
          delBtn0.type = 'button';
          delBtn0.className = 'ce-remove-row-btn';
          delBtn0.innerHTML = '×';
          delBtn0.title = 'Remove option';
          delBtn0.addEventListener('click', () => {
            firstRow.remove();
            checkCardSelectionState(cardEl);
          });
          firstRow.appendChild(delBtn0);
        }

        const delBtnClone = document.createElement('button');
        delBtnClone.type = 'button';
        delBtnClone.className = 'ce-remove-row-btn';
        delBtnClone.innerHTML = '×';
        delBtnClone.title = 'Remove option';
        delBtnClone.addEventListener('click', () => {
          clone.remove();
          checkCardSelectionState(cardEl);
        });
        clone.appendChild(delBtnClone);

        container.appendChild(clone);
        setupRowListeners(cardEl, clone, false);
      });
    }
  });

  /* ── 2. Badge Update ── */
  function updateGlobalBulkInfo() {
    let totalCapsCount = 0;
    productCards.forEach(card => {
      totalCapsCount += getCardTotalQty(card);
    });

    const badgeEl = document.getElementById('ce-selected-count-badge');
    if (badgeEl) {
      badgeEl.textContent = totalCapsCount > 0
        ? `${totalCapsCount} cap${totalCapsCount === 1 ? '' : 's'} selected`
        : '0 items selected';
    }

    const saveMsgEl = document.getElementById('ce-global-save-msg');
    if (saveMsgEl) {
      if (totalCapsCount >= 20) {
        saveMsgEl.textContent = 'You\'ve unlocked the 10% bulk discount and the Digitizing / Setup Fee is waived!';
      } else if (totalCapsCount > 0) {
        const needed = 20 - totalCapsCount;
        saveMsgEl.textContent = `Add ${needed} more cap${needed === 1 ? '' : 's'} to unlock 10% off and waive the setup fee!`;
      } else {
        saveMsgEl.textContent = 'Select hats below. Orders over 20 units get a flat 10% discount and no setup fee!';
      }
    }
  }

  /* ── 3. Step 2: Uploadcare & Saved Designs ── */
  const uploadInput = document.getElementById('ce-uploadcare-input');
  if (uploadInput && typeof uploadcare !== 'undefined') {
    const widget = uploadcare.SingleWidget(uploadInput);
    widget.onUploadComplete(function(fileInfo) {
      if (fileInfo && fileInfo.cdnUrl) {
        activeDesignUrl = fileInfo.cdnUrl;
        activeDesignName = fileInfo.name || 'custom_logo.png';
        activeDesignType = 'new';
        
        activeDesignIsHighDpi = false;
        let uploadedDpiText = 'Unknown DPI';
        
        if (fileInfo.originalImageInfo && fileInfo.originalImageInfo.dpi && fileInfo.originalImageInfo.dpi.length > 0) {
          const dpiVal = fileInfo.originalImageInfo.dpi[0];
          uploadedDpiText = `${dpiVal} DPI`;
          if (dpiVal >= 300) {
            activeDesignIsHighDpi = true;
          }
        }

        document.getElementById('ce-active-design-url').value = activeDesignUrl;
        document.getElementById('ce-active-design-name').value = activeDesignName;
        document.getElementById('ce-active-design-type').value = 'new';

        const previewBox = document.getElementById('ce-upload-preview-box');
        const previewImg = document.getElementById('ce-uploaded-img-preview');
        const filenameEl = document.getElementById('ce-uploaded-filename');
        const dpiEl = document.getElementById('ce-uploaded-dpi');
        
        if (previewImg) previewImg.src = activeDesignUrl;
        if (filenameEl) filenameEl.textContent = activeDesignName;
        
        if (dpiEl) {
          dpiEl.textContent = `Detected Resolution: ${uploadedDpiText}`;
          if (activeDesignIsHighDpi) {
            dpiEl.style.color = '#16a34a'; // green
            dpiEl.textContent += ' (Setup Fee Waived)';
          } else {
            dpiEl.style.color = '#dc2626'; // red
            dpiEl.textContent += ' (Under 300 DPI - Setup Fee Applies)';
          }
        }
        
        if (previewBox) previewBox.style.display = 'inline-flex';

        updatePlacementOverlayPreview(activeDesignUrl);
        buildOrderSummary();
      }
    });
  }

  const removeUploadBtn = document.getElementById('ce-remove-upload');
  if (removeUploadBtn && uploadInput && typeof uploadcare !== 'undefined') {
    removeUploadBtn.addEventListener('click', () => {
      const widget = uploadcare.SingleWidget(uploadInput);
      widget.value(null);
      activeDesignUrl = '';
      activeDesignName = '';
      activeDesignIsHighDpi = false;
      const previewBox = document.getElementById('ce-upload-preview-box');
      const dpiEl = document.getElementById('ce-uploaded-dpi');
      if (dpiEl) dpiEl.textContent = '';
      if (previewBox) previewBox.style.display = 'none';
      updatePlacementOverlayPreview('');
      buildOrderSummary();
    });
  }

  // Upload vs Saved Tabs
  const tabNewBtn = document.getElementById('ce-tab-new');
  const tabSavedBtn = document.getElementById('ce-tab-saved');
  const panelNew = document.getElementById('ce-panel-new');
  const panelSaved = document.getElementById('ce-panel-saved');

  if (tabNewBtn && tabSavedBtn) {
    tabNewBtn.addEventListener('click', () => {
      tabNewBtn.classList.add('ce-upload-tab--active');
      tabSavedBtn.classList.remove('ce-upload-tab--active');
      if (panelNew) panelNew.style.display = 'block';
      if (panelSaved) panelSaved.style.display = 'none';
    });
    tabSavedBtn.addEventListener('click', () => {
      tabSavedBtn.classList.add('ce-upload-tab--active');
      tabNewBtn.classList.remove('ce-upload-tab--active');
      if (panelSaved) panelSaved.style.display = 'block';
      if (panelNew) panelNew.style.display = 'none';
      loadSavedDesigns();
    });
  }

  let savedDesignsLoaded = false;
  function loadSavedDesigns() {
    if (savedDesignsLoaded || !customerId) return;
    savedDesignsLoaded = true;
    const loadingEl = document.getElementById('ce-saved-loading');
    const emptyEl = document.getElementById('ce-saved-empty');

    fetch('/account?view=orders')
      .then(res => res.text())
      .then(html => {
        if (loadingEl) loadingEl.style.display = 'none';
        if (emptyEl) emptyEl.style.display = 'block';
      })
      .catch(err => {
        if (loadingEl) loadingEl.style.display = 'none';
        if (emptyEl) emptyEl.style.display = 'block';
      });
  }

  /* ── 4. Step 3: Global Embroidery Style, Placement & Thread Colors ── */
  const globalEmbBtns = document.querySelectorAll('.ce-global-emb-btn');
  globalEmbBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      globalEmbBtns.forEach(b => {
        b.classList.remove('ce-global-emb-btn--active');
        b.style.borderColor = '#cbd5e1';
        b.style.background = '#fff';
        b.style.color = '#334155';
      });
      btn.classList.add('ce-global-emb-btn--active');
      btn.style.borderColor = '#0f172a';
      btn.style.background = '#0f172a';
      btn.style.color = '#fff';
      activeEmbStyle = btn.getAttribute('data-value') || 'Flat Embroidery';
      buildOrderSummary();
    });
  });

  function updateMultiPlacementContainer() {
    const container = document.getElementById('ce-multi-placement-container');
    const defaultGrid = document.getElementById('ce-placement-grid');
    if (!container || !defaultGrid) return;

    const previewItemsMap = new Map();
    productCards.forEach(cardEl => {
      if (cardEl.style.display === 'none') return;
      const pid = cardEl.dataset.productId;
      const data = cardDataMap.get(pid);
      const checkbox = cardEl.querySelector('.ce-card-checkbox');
      const rows = Array.from(cardEl.querySelectorAll('.ce-variant-row'));

      rows.forEach(rowEl => {
        const inp = rowEl.querySelector('.ce-qty-input');
        const qty = parseInt(inp?.value, 10) || 0;
        const v = getRowVariant(cardEl, rowEl);

        if (qty > 0 || (checkbox && checkbox.checked)) {
          const key = pid + '_' + (v ? v.id : 'base');
          if (!previewItemsMap.has(key)) {
            let imgUrl = '';
            if (v && v.featured_image && v.featured_image.src) imgUrl = v.featured_image.src;
            else if (v && v.image && v.image.src) imgUrl = v.image.src;
            else imgUrl = cardEl.dataset.featuredImage || (cardEl.querySelector('.ce-card-image') ? cardEl.querySelector('.ce-card-image').src : '');

            previewItemsMap.set(key, {
              productId: pid,
              productTitle: data ? data.title : (cardEl.dataset.productTitle || 'Hat Item'),
              variantId: v ? v.id : null,
              variantTitle: (v && v.title !== 'Default Title') ? v.title : '',
              imageUrl: imgUrl
            });
          }
        }
      });
    });

    const previewItems = Array.from(previewItemsMap.values()).slice(0, 1);
    if (previewItems.length === 0) {
      container.style.display = 'none';
      container.innerHTML = '';
      defaultGrid.style.display = '';
      return;
    }

    defaultGrid.style.display = 'none';
    container.style.display = 'flex';

    container.innerHTML = previewItems.map(item => `
      <div class="ce-mp-block" data-product-id="${item.productId}" data-variant-id="${item.variantId || ''}">
        <div class="ce-mp-header">
          <div class="ce-mp-info">
            ${item.imageUrl ? `<img src="${item.imageUrl}" class="ce-mp-thumb" alt="${item.productTitle}">` : ''}
            <div>
              <h4 class="ce-mp-title">${item.productTitle}</h4>
              ${item.variantTitle ? `<span class="ce-mp-variant-badge">${item.variantTitle}</span>` : ''}
            </div>
          </div>
          <div class="ce-mp-placement-status">Location: <span class="ce-mp-selected-label">${activePlacement}</span></div>
        </div>
        <div class="ce-placement-grid" style="grid-template-columns: repeat(3, 1fr); gap: 16px;">
          ${['Left Panel', 'Centered', 'Right Panel'].map(loc => {
            const zoneClass = loc === 'Left Panel' ? 'ce-zone-left' : (loc === 'Centered' ? 'ce-zone-center' : 'ce-zone-right');
            const wrapClass = loc === 'Centered' ? 'ce-zone-center-large' : 'ce-zone-small';
            const isActive = activePlacement === loc;
            const st = placementState[loc] || {x: 0, y: 0, scale: 1.0, rotate: 0};
            return `
              <div class="ce-placement-card ${isActive ? 'ce-placement-card--active' : ''}" data-placement="${loc}">
                <div class="ce-placement-img-wrap ${wrapClass}">
                  ${item.imageUrl ? `<img src="${item.imageUrl}" class="ce-mp-garment-img" style="position:absolute; inset:0; width:100%; height:100%; object-fit:contain; transform:scale(1.15); z-index:5;" alt="${loc}" crossorigin="anonymous">` : ''}
                  <div class="ce-placement-logo-overlay ${zoneClass}" data-placement="${loc}" style="z-index:10;">
                    <img class="ce-logo-preview" src="${activeDesignUrl}" style="display:${activeDesignUrl ? 'block' : 'none'}; transform: translate(${st.x}px, ${st.y}px) scale(${st.scale}) rotate(${st.rotate || 0}deg); cursor: move;" crossorigin="anonymous">
                  </div>
                </div>
                <span class="ce-placement-label">${loc}</span>
              </div>
            `;
          }).join('')}
        </div>
      </div>
    `).join('');

    container.querySelectorAll('.ce-placement-card').forEach(card => {
      card.addEventListener('click', () => {
        const newPlacement = card.dataset.placement || 'Left Panel';
        if (newPlacement === activePlacement) return; // Prevent resetting when clicking the active card!
        activePlacement = newPlacement;
        // DO NOT reset transform! Update slider to match new placement scale
        const st = placementState[activePlacement] || {x: 0, y: 0, scale: 1.0, rotate: 0};
        const scaleSlider = document.getElementById('ce-logo-scale');
        const scaleValDisplay = document.getElementById('ce-logo-scale-val');
        if (scaleSlider) scaleSlider.value = st.scale;
        if (scaleValDisplay) scaleValDisplay.textContent = Math.round(st.scale * 100) + '%';
        const rotateSlider = document.getElementById('ce-logo-rotate');
        const rotateValDisplay = document.getElementById('ce-logo-rotate-val');
        if (rotateSlider) rotateSlider.value = st.rotate || 0;
        if (rotateValDisplay) rotateValDisplay.textContent = (st.rotate || 0) + '°';
        document.querySelectorAll('.ce-placement-card').forEach(c => {
          c.classList.toggle('ce-placement-card--active', c.dataset.placement === activePlacement);
        });
        document.querySelectorAll('.ce-mp-selected-label').forEach(el => el.textContent = activePlacement);
        buildOrderSummary();
      });
    });
  }

  const placementCards = document.querySelectorAll('.ce-placement-card');
  placementCards.forEach(pCard => {
    pCard.addEventListener('click', () => {
      const newPlacement = pCard.getAttribute('data-placement') || 'Left Panel';
      if (newPlacement === activePlacement) return; // Prevent resetting when clicking the active card!
      
      placementCards.forEach(c => c.classList.remove('ce-placement-card--active'));
      pCard.classList.add('ce-placement-card--active');
      activePlacement = newPlacement;
      // Update slider to match new placement scale
      const st = placementState[activePlacement] || {x: 0, y: 0, scale: 1.0, rotate: 0};
      const scaleSlider = document.getElementById('ce-logo-scale');
      const scaleValDisplay = document.getElementById('ce-logo-scale-val');
      if (scaleSlider) scaleSlider.value = st.scale;
      if (scaleValDisplay) scaleValDisplay.textContent = Math.round(st.scale * 100) + '%';
      const rotateSlider = document.getElementById('ce-logo-rotate');
      const rotateValDisplay = document.getElementById('ce-logo-rotate-val');
      if (rotateSlider) rotateSlider.value = st.rotate || 0;
      if (rotateValDisplay) rotateValDisplay.textContent = (st.rotate || 0) + '°';
      updateMultiPlacementContainer();
      buildOrderSummary();
    });
  });

  function updatePlacementOverlayPreview(imgUrl) {
    document.querySelectorAll('.ce-logo-preview').forEach(imgEl => {
      if (imgUrl) {
        imgEl.src = imgUrl;
        imgEl.style.display = 'block';
      } else {
        imgEl.src = '';
        imgEl.style.display = 'none';
      }
    });
    // Call update for additional locations if defined
    if (typeof updateAddLocPreview === 'function') {
      Object.keys(addLocData).forEach(updateAddLocPreview);
    }
  }

  // --- DRAG AND DROP LOGO LOGIC ---
  let isDragging = false;
  let dragTarget = null;
  let startX, startY;

  document.addEventListener('mousedown', (e) => {
    if (e.target.classList.contains('ce-logo-preview') || e.target.classList.contains('ce-art-preview')) {
      isDragging = true;
      dragTarget = e.target;
      const overlay = dragTarget.closest('.ce-placement-logo-overlay');
      if (overlay) overlay.classList.add('is-dragging');
      dragTarget.style.cursor = 'move';
      
      const style = window.getComputedStyle(dragTarget);
      const matrix = new DOMMatrixReadOnly(style.transform === 'none' ? 'matrix(1, 0, 0, 1, 0, 0)' : style.transform);
      const currentX = matrix.m41;
      const currentY = matrix.m42;
      
      startX = e.clientX - currentX;
      startY = e.clientY - currentY;
      
      e.preventDefault(); // Prevent native image drag
    }
  });

  document.addEventListener('mousemove', (e) => {
    if (!isDragging || !dragTarget) return;
    const currentX = e.clientX - startX;
    const currentY = e.clientY - startY;
    
    const overlay = dragTarget.closest('.ce-placement-logo-overlay');
    const pName = overlay ? overlay.dataset.placement : activePlacement;
    
    if (placementState[pName]) {
      placementState[pName].x = currentX;
      placementState[pName].y = currentY;
      
      const activeImgs = document.querySelectorAll(`.ce-placement-logo-overlay[data-placement="${pName}"] .ce-logo-preview, .ce-placement-logo-overlay[data-placement="${pName}"] .ce-art-preview`);
      activeImgs.forEach(img => {
        img.style.transform = `translate(${currentX}px, ${currentY}px) scale(${placementState[pName].scale}) rotate(${placementState[pName].rotate || 0}deg)`;
      });
    }
  });

  document.addEventListener('mouseup', (e) => {
    if (isDragging && dragTarget) {
      const overlay = dragTarget.closest('.ce-placement-logo-overlay');
      if (overlay) overlay.classList.remove('is-dragging');
      dragTarget.style.cursor = 'move';
      isDragging = false;
      dragTarget = null;
    }
  });

  // --- LOGO RESIZE & ROTATE LOGIC ---
  document.addEventListener('input', (e) => {
    if (e.target.id === 'ce-logo-scale') {
      const newScale = parseFloat(e.target.value);
      const scaleValDisplay = document.getElementById('ce-logo-scale-val');
      if (scaleValDisplay) scaleValDisplay.textContent = Math.round(newScale * 100) + '%';
      
      if (placementState[activePlacement]) {
        placementState[activePlacement].scale = newScale;
      }
      
      const activeImgs = document.querySelectorAll(`.ce-placement-logo-overlay[data-placement="${activePlacement}"] .ce-logo-preview`);
      if (placementState[activePlacement]) {
        const {x, y, scale, rotate} = placementState[activePlacement];
        activeImgs.forEach(img => {
          img.style.transform = `translate(${x}px, ${y}px) scale(${scale}) rotate(${rotate || 0}deg)`;
        });
      }
    } else if (e.target.id === 'ce-logo-rotate') {
      const deg = parseInt(e.target.value, 10);
      const rotateValDisplay = document.getElementById('ce-logo-rotate-val');
      if (rotateValDisplay) rotateValDisplay.textContent = deg + '°';

      document.querySelectorAll('.ce-main-rotate-preset-btn').forEach(btn => {
        btn.classList.toggle('ce-main-rotate-preset--active', parseInt(btn.dataset.deg, 10) === deg);
      });

      if (placementState[activePlacement]) {
        placementState[activePlacement].rotate = deg;
      }

      const activeImgs = document.querySelectorAll(`.ce-placement-logo-overlay[data-placement="${activePlacement}"] .ce-logo-preview`);
      if (placementState[activePlacement]) {
        const {x, y, scale, rotate} = placementState[activePlacement];
        activeImgs.forEach(img => {
          img.style.transform = `translate(${x}px, ${y}px) scale(${scale}) rotate(${rotate || 0}deg)`;
        });
      }
    }
  });

  document.addEventListener('click', e => {
    const rotateBtn = e.target.closest('.ce-main-rotate-preset-btn');
    if (rotateBtn) {
      const deg = parseInt(rotateBtn.dataset.deg, 10);
      const rotateSlider = document.getElementById('ce-logo-rotate');
      const rotateValDisplay = document.getElementById('ce-logo-rotate-val');
      if (rotateSlider) rotateSlider.value = deg;
      if (rotateValDisplay) rotateValDisplay.textContent = deg + '°';
      document.querySelectorAll('.ce-main-rotate-preset-btn').forEach(b => b.classList.remove('ce-main-rotate-preset--active'));
      rotateBtn.classList.add('ce-main-rotate-preset--active');

      if (placementState[activePlacement]) {
        placementState[activePlacement].rotate = deg;
      }
      
      const activeImgs = document.querySelectorAll(`.ce-placement-logo-overlay[data-placement="${activePlacement}"] .ce-logo-preview`);
      if (placementState[activePlacement]) {
        const {x, y, scale, rotate} = placementState[activePlacement];
        activeImgs.forEach(img => {
          img.style.transform = `translate(${x}px, ${y}px) scale(${scale}) rotate(${rotate || 0}deg)`;
        });
      }
    }
  });

  // --------------------------------

  // --- ADDITIONAL LOCATIONS LOGIC ---
  let activeAddLoc = 'Back';

  function setActiveAddLoc(locName) {
    if (!locName) return;
    activeAddLoc = locName;

    // Update pill buttons
    document.querySelectorAll('.ce-add-loc-pill').forEach(btn => {
      const isMatch = btn.dataset.location === locName;
      btn.classList.toggle('ce-add-loc-pill--active', isMatch);
      btn.style.background = isMatch ? '#1a4fa0' : 'transparent';
      btn.style.color = isMatch ? '#ffffff' : '#475569';
    });

    // Update active card highlight
    document.querySelectorAll('.ce-add-loc-card').forEach(card => {
      const cardLoc = card.dataset.location;
      card.classList.toggle('ce-add-loc-card--active', locName === 'all' || cardLoc === locName);
    });

    // Update scale and rotate controls to reflect active location state
    const addLocScaleSlider = document.getElementById('ce-add-loc-scale');
    const addLocScaleVal = document.getElementById('ce-add-loc-scale-val');
    const addLocRotateSlider = document.getElementById('ce-add-loc-rotate');
    const addLocRotateVal = document.getElementById('ce-add-loc-rotate-val');

    const targetLoc = (locName === 'all') ? 'Back' : locName;
    const state = placementState[targetLoc] || { x: 0, y: 0, scale: 1.0, rotate: 0 };

    if (addLocScaleSlider) addLocScaleSlider.value = state.scale;
    if (addLocScaleVal) addLocScaleVal.textContent = Math.round(state.scale * 100) + '%';
    if (addLocRotateSlider) addLocRotateSlider.value = state.rotate || 0;
    if (addLocRotateVal) addLocRotateVal.textContent = (state.rotate || 0) + '°';

    // Update preset rotate buttons
    document.querySelectorAll('.ce-rotate-preset-btn').forEach(btn => {
      const deg = parseInt(btn.dataset.deg, 10);
      btn.classList.toggle('ce-rotate-preset--active', deg === (state.rotate || 0));
    });
  }

  document.querySelectorAll('.ce-add-loc-card').forEach(card => {
    card.addEventListener('click', e => {
      if (['INPUT', 'TEXTAREA', 'BUTTON'].includes(e.target.tagName)) return;
      const loc = card.dataset.location;
      if (loc) setActiveAddLoc(loc);
    });
  });

  document.addEventListener('input', e => {
    if (e.target.id === 'ce-add-loc-scale') {
      const val = parseFloat(e.target.value);
      const valSpan = document.getElementById('ce-add-loc-scale-val');
      if (valSpan) valSpan.textContent = Math.round(val * 100) + '%';

      const locsToUpdate = (activeAddLoc === 'all') ? ['Back', 'Left Side', 'Right Side'] : [activeAddLoc];
      locsToUpdate.forEach(loc => {
        if (placementState[loc]) {
          placementState[loc].scale = val;
          const {x, y, scale, rotate} = placementState[loc];
          const imgs = document.querySelectorAll(`.ce-placement-logo-overlay[data-placement="${loc}"] .ce-art-preview`);
          imgs.forEach(img => {
            img.style.transform = `translate(${x}px, ${y}px) scale(${scale}) rotate(${rotate || 0}deg)`;
          });
        }
      });
    } else if (e.target.id === 'ce-add-loc-rotate') {
      const deg = parseInt(e.target.value, 10);
      const valSpan = document.getElementById('ce-add-loc-rotate-val');
      if (valSpan) valSpan.textContent = deg + '°';

      document.querySelectorAll('.ce-rotate-preset-btn').forEach(btn => {
        btn.classList.toggle('ce-rotate-preset--active', parseInt(btn.dataset.deg, 10) === deg);
      });

      const locsToUpdate = (activeAddLoc === 'all') ? ['Back', 'Left Side', 'Right Side'] : [activeAddLoc];
      locsToUpdate.forEach(loc => {
        if (placementState[loc]) {
          placementState[loc].rotate = deg;
          const {x, y, scale, rotate} = placementState[loc];
          const imgs = document.querySelectorAll(`.ce-placement-logo-overlay[data-placement="${loc}"] .ce-art-preview`);
          imgs.forEach(img => {
            img.style.transform = `translate(${x}px, ${y}px) scale(${scale}) rotate(${rotate || 0}deg)`;
          });
        }
      });
    }
  });

  document.addEventListener('click', e => {
    const pill = e.target.closest('.ce-add-loc-pill');
    if (pill) {
      setActiveAddLoc(pill.dataset.location);
    }

    const rotateBtn = e.target.closest('.ce-rotate-preset-btn');
    if (rotateBtn) {
      const deg = parseInt(rotateBtn.dataset.deg, 10);
      const rotateSlider = document.getElementById('ce-add-loc-rotate');
      const rotateVal = document.getElementById('ce-add-loc-rotate-val');
      if (rotateSlider) rotateSlider.value = deg;
      if (rotateVal) rotateVal.textContent = deg + '°';
      document.querySelectorAll('.ce-rotate-preset-btn').forEach(b => b.classList.remove('ce-rotate-preset--active'));
      rotateBtn.classList.add('ce-rotate-preset--active');

      const locsToUpdate = (activeAddLoc === 'all') ? ['Back', 'Left Side', 'Right Side'] : [activeAddLoc];
      locsToUpdate.forEach(loc => {
        if (placementState[loc]) {
          placementState[loc].rotate = deg;
          const {x, y, scale, rotate} = placementState[loc];
          const imgs = document.querySelectorAll(`.ce-placement-logo-overlay[data-placement="${loc}"] .ce-art-preview`);
          imgs.forEach(img => {
            img.style.transform = `translate(${x}px, ${y}px) scale(${scale}) rotate(${rotate || 0}deg)`;
          });
        }
      });
    }
  });

  const addLocCheckboxes = document.querySelectorAll('.ce-add-loc-chk');
  const addLocData = {
    'Back': { checked: false, details: '', url: '', inputs: document.getElementById('ce-inputs-back'), text: document.getElementById('ce-text-back'), upload: document.getElementById('ce-upload-back'), name: 'Back' },
    'Left Side': { checked: false, details: '', url: '', inputs: document.getElementById('ce-inputs-left'), text: document.getElementById('ce-text-left'), upload: document.getElementById('ce-upload-left'), name: 'Left Side' },
    'Right Side': { checked: false, details: '', url: '', inputs: document.getElementById('ce-inputs-right'), text: document.getElementById('ce-text-right'), upload: document.getElementById('ce-upload-right'), name: 'Right Side' }
  };

  Object.keys(addLocData).forEach(key => {
    const loc = addLocData[key];
    const chk = document.getElementById(key === 'Back' ? 'ce-chk-back' : key === 'Left Side' ? 'ce-chk-left' : 'ce-chk-right');
    if (chk) {
      chk.addEventListener('change', (e) => {
        loc.checked = e.target.checked;
        if (loc.inputs) {
          loc.inputs.style.display = loc.checked ? 'block' : 'none';
        }
        if (loc.checked) {
          setActiveAddLoc(loc.name);
        }
        buildOrderSummary();
      });
    }
  });

  function updateAddLocPreview(locName) {
    const loc = addLocData[locName];
    const previewImgClass = locName === 'Back' ? '.ce-art-preview-back' : locName === 'Left Side' ? '.ce-art-preview-left-side' : '.ce-art-preview-right-side';
    const previewImg = document.querySelector(previewImgClass);
    if (!previewImg) return;

    const hasCustomLogo = loc.url;
    const hasOriginalLogo = activeDesignUrl;

    if (hasCustomLogo) {
      previewImg.src = loc.url;
      previewImg.style.display = 'block';
    } else if (hasOriginalLogo) {
      previewImg.src = activeDesignUrl;
      previewImg.style.display = 'block';
    } else {
      previewImg.src = '';
      previewImg.style.display = 'none';
    }

    if (placementState[locName]) {
      const {x, y, scale, rotate} = placementState[locName];
      previewImg.style.transform = `translate(${x}px, ${y}px) scale(${scale}) rotate(${rotate || 0}deg)`;
    }
  }



  const addLocUploadInputs = {
    'Back': document.getElementById('ce-upload-back'),
    'Left Side': document.getElementById('ce-upload-left'),
    'Right Side': document.getElementById('ce-upload-right')
  };

  if (typeof uploadcare !== 'undefined') {
    Object.keys(addLocUploadInputs).forEach(locName => {
      const inp = addLocUploadInputs[locName];
      if (inp) {
        const widget = uploadcare.SingleWidget(inp);
        widget.onUploadComplete(function(fileInfo) {
          if (fileInfo && fileInfo.cdnUrl) {
            addLocData[locName].url = fileInfo.cdnUrl;
            updateAddLocPreview(locName);
          }
        });
        widget.onChange(function(file) {
          if (!file) {
            addLocData[locName].url = '';
            updateAddLocPreview(locName);
          }
        });
      }
    });
  }
  
  // Render Tier Display in UI
  const addLocTierDisplay = document.getElementById('ce-add-loc-tiers-display');
  if (addLocTierDisplay) {
    if (ADD_LOC_TIERS.length > 0) {
      // Create reverse array for display
      const displayTiers = [...ADD_LOC_TIERS].reverse();
      let theadHtml = '<tr><th class="pb-th-label">TIER QTY</th>';
      let tbodyHtml = '<tr><td class="pb-td-label">PRICE</td>';
      
      displayTiers.forEach(t => {
        theadHtml += `<th>${t.min}+</th>`;
        tbodyHtml += `<td>$${t.price.toFixed(2)}</td>`;
      });
      
      theadHtml += '</tr>';
      tbodyHtml += '</tr>';
      
      addLocTierDisplay.innerHTML = `<table class="pb-table"><thead>${theadHtml}</thead><tbody>${tbodyHtml}</tbody></table>`;
    } else {
      addLocTierDisplay.innerHTML = `<p><strong>$10.00</strong> / location</p>`;
    }
  }
  // ----------------------------------

  const threadItems = document.querySelectorAll('.ce-thread-item');
  threadItems.forEach(item => {
    item.addEventListener('click', () => {
      const cname = item.getAttribute('data-thread-name');
      if (item.classList.contains('ce-thread--selected')) {
        item.classList.remove('ce-thread--selected');
        selectedThreadColors = selectedThreadColors.filter(c => c !== cname);
      } else {
        if (selectedThreadColors.length >= 15) {
          alert('You can select a maximum of 15 thread colors.');
          return;
        }
        item.classList.add('ce-thread--selected');
        selectedThreadColors.push(cname);
      }
      buildOrderSummary();
    });
  });

  const colorNotesInp = document.getElementById('ce-color-notes-input');
  if (colorNotesInp) {
    colorNotesInp.addEventListener('input', () => buildOrderSummary());
  }

  /* ── 5. Review Order Summary ── */
  function buildOrderSummary() {
    const listEl = document.getElementById('ce-summary-items-list');
    if (!listEl) return;
    listEl.innerHTML = '';

    let totalCapsCount = 0;
    let hasItems = false;

    productCards.forEach(card => {
      const title = card.dataset.productTitle || 'Cap Item';
      const rows = card.querySelectorAll('.ce-variant-row');

      rows.forEach(row => {
        const inp = row.querySelector('.ce-qty-input');
        const qty = parseInt(inp ? inp.value : '0', 10);
        if (qty > 0) {
          hasItems = true;
          totalCapsCount += qty;
          const variant = getRowVariant(card, row);
          let varTitle = variant ? variant.title : 'Standard';
          if (varTitle === 'Default Title') varTitle = 'Standard OSFA';

          // Get actual product price from the variant
          const productPrice = variant && variant.price ? variant.price / 100 : 0;
          // Apply 10% off when total order qty >= 20, otherwise full price
          const unitPrice = getTierPrice(totalCapsCount, productPrice);
          const subtotal = qty * unitPrice;

          const lineEl = document.createElement('div');
          lineEl.className = 'ce-summary-line-item';
          lineEl.innerHTML = `
            <div>
              <div class="ce-summary-line-title">${title} — ${varTitle}</div>
              <div class="ce-summary-line-sub">Embroidery Style: ${activeEmbStyle} | Placement: ${activePlacement}</div>
            </div>
            <div class="ce-summary-line-cost">${qty} @ $${unitPrice.toFixed(2)} = $${subtotal.toFixed(2)}</div>
          `;
          listEl.appendChild(lineEl);
        }
      });
    });

    if (!hasItems) {
      listEl.innerHTML = `<p class="ce-summary-empty-note" style="font-style: italic; color: #666666; font-size: 13px; margin: 0;">No hat items selected yet. Choose products and quantities in Step 1 above.</p>`;
    }

    const embOptEl = document.getElementById('ce-summary-emb-option');
    const placementEl = document.getElementById('ce-summary-placement');
    const artStatusEl = document.getElementById('ce-summary-art-status');
    const threadColorsEl = document.getElementById('ce-summary-thread-colors');
    const notesEl = document.getElementById('ce-summary-notes');

    if (embOptEl) embOptEl.textContent = activeEmbStyle;
    if (placementEl) placementEl.textContent = activePlacement;
    const bypassRadio = document.querySelector('input[name="ce_logo_bypass"]:checked');
    const bypassVal = bypassRadio ? bypassRadio.value : 'upload';
    let artStatusMsg = 'No artwork provided';
    if (bypassVal === 'ordered_before') {
      artStatusMsg = 'Will use logo from previous order (Bypass)';
    } else if (bypassVal === 'email_later') {
      artStatusMsg = 'Will submit later via email (Bypass)';
    } else if (activeDesignUrl) {
      artStatusMsg = (activeDesignType === 'saved') ? 'Saved Design from Order History' : 'New Artwork Upload';
    }
    
    if (artStatusEl) artStatusEl.textContent = artStatusMsg;
    if (threadColorsEl) threadColorsEl.textContent = selectedThreadColors.length > 0 ? selectedThreadColors.join(', ') : 'None selected';
    if (notesEl) notesEl.textContent = (colorNotesInp && colorNotesInp.value.trim()) ? colorNotesInp.value.trim() : 'None';

    const totalQtyEl = document.getElementById('ce-sum-total-qty');
    const tierPriceEl = document.getElementById('ce-sum-tier-price');
    const capsCostEl = document.getElementById('ce-sum-caps-cost');
    const embQtyEl = document.getElementById('ce-sum-emb-qty');
    const embCostEl = document.getElementById('ce-sum-emb-cost');
    const setupRowEl = document.getElementById('ce-sum-setup-fee-row');
    const setupStatusEl = document.getElementById('ce-sum-setup-status');
    const setupCostEl = document.getElementById('ce-sum-setup-cost');
    const grandTotalEl = document.getElementById('ce-sum-grand-total');

    // Recompute totalCapsCost by summing actual per-product prices (with 10% if qty>=20)
    let totalCapsCost = 0;
    productCards.forEach(card => {
      card.querySelectorAll('.ce-variant-row').forEach(row => {
        const inp = row.querySelector('.ce-qty-input');
        const qty = parseInt(inp ? inp.value : '0', 10);
        if (qty > 0) {
          const v = getRowVariant(card, row);
          const pp = v && v.price ? v.price / 100 : 0;
          totalCapsCost += qty * getTierPrice(totalCapsCount, pp);
        }
      });
    });
    const avgUnitPrice = totalCapsCount > 0 ? totalCapsCost / totalCapsCount : 0;

    const embroideryFeeTotal = totalCapsCount * embroideryFeePrice;

    // Setup fee: waived when qty >= 20 OR high-DPI upload OR saved design
    let setupFeeAmt = 0;
    if (totalCapsCount >= 20) {
      // Over 20 units: always waive setup fee
      setupFeeAmt = 0;
      if (setupRowEl) {
        setupRowEl.style.display = 'flex';
        if (setupStatusEl) setupStatusEl.textContent = 'Waived (20+ unit order)';
        if (setupCostEl) setupCostEl.textContent = '$0.00';
      }
    } else if (totalCapsCount > 0 && activeDesignType === 'new') {
      if (activeDesignIsHighDpi) {
        setupFeeAmt = 0;
        if (setupRowEl) setupRowEl.style.display = 'none';
      } else {
        setupFeeAmt = setupFeePrice;
        if (setupRowEl) setupRowEl.style.display = 'flex';
        if (setupStatusEl) setupStatusEl.textContent = `Flat one-time fee per order ($${setupFeePrice.toFixed(2)})`;
        if (setupCostEl) setupCostEl.textContent = `$${setupFeeAmt.toFixed(2)}`;
      }
    } else if (totalCapsCount > 0 && activeDesignType === 'saved') {
      if (setupRowEl) setupRowEl.style.display = 'flex';
      if (setupStatusEl) setupStatusEl.textContent = 'Saved Design Exemption';
      if (setupCostEl) setupCostEl.textContent = '$0.00 (Waived)';
    } else {
      if (setupRowEl) setupRowEl.style.display = 'flex';
      if (setupStatusEl) setupStatusEl.textContent = `Flat one-time fee per order ($${setupFeePrice.toFixed(2)})`;
      if (setupCostEl) setupCostEl.textContent = `$${setupFeePrice.toFixed(2)}`;
      if (totalCapsCount === 0) setupFeeAmt = 0;
    }


    let extraLocationsCount = 0;
    if (addLocData['Back'] && addLocData['Back'].checked) extraLocationsCount++;
    if (addLocData['Left Side'] && addLocData['Left Side'].checked) extraLocationsCount++;
    if (addLocData['Right Side'] && addLocData['Right Side'].checked) extraLocationsCount++;

    const addLocTotalInstances = extraLocationsCount * totalCapsCount;
    const addLocTierPrice = getAddLocTierPrice(addLocTotalInstances);
    const addLocFeeTotal = addLocTotalInstances * addLocTierPrice;

    const addLocRowEl = document.getElementById('ce-sum-add-loc-fee-row');
    const addLocQtyEl = document.getElementById('ce-sum-add-loc-qty');
    const addLocTierPriceEl = document.getElementById('ce-sum-add-loc-tier-price');
    const addLocCostEl = document.getElementById('ce-sum-add-loc-cost');

    if (extraLocationsCount > 0 && totalCapsCount > 0) {
      if (addLocRowEl) addLocRowEl.style.display = 'flex';
      if (addLocQtyEl) addLocQtyEl.textContent = addLocTotalInstances;
      if (addLocTierPriceEl) addLocTierPriceEl.textContent = addLocTierPrice.toFixed(2);
      if (addLocCostEl) addLocCostEl.textContent = `$${addLocFeeTotal.toFixed(2)}`;
    } else {
      if (addLocRowEl) addLocRowEl.style.display = 'none';
    }

    const grandTotal = totalCapsCost + embroideryFeeTotal + setupFeeAmt + addLocFeeTotal;

    // Update Items Subtotal subtext
    const capsSubtextEl = document.getElementById('ce-sum-caps-subtext');
    if (capsSubtextEl) {
      if (totalCapsCount > 0) {
        capsSubtextEl.textContent = totalCapsCount >= 20
          ? `Base price of selected products (@ $${avgUnitPrice.toFixed(2)}/each, 10% discount applied)`
          : `Base price of selected products (@ $${avgUnitPrice.toFixed(2)}/each)`;
      } else {
        capsSubtextEl.textContent = '';
      }
    }

    if (totalQtyEl) totalQtyEl.textContent = totalCapsCount;
    if (tierPriceEl) tierPriceEl.textContent = `$${avgUnitPrice.toFixed(2)}`;
    if (capsCostEl) capsCostEl.textContent = `$${totalCapsCost.toFixed(2)}`;
    if (embQtyEl) embQtyEl.textContent = totalCapsCount;
    if (embCostEl) embCostEl.textContent = `$${embroideryFeeTotal.toFixed(2)}`;
    if (setupCostEl) setupCostEl.textContent = `$${(totalCapsCount > 0 ? setupFeeAmt : setupFeePrice).toFixed(2)}`;
    if (grandTotalEl) grandTotalEl.textContent = `$${grandTotal.toFixed(2)}`;

    // Update Sticky Bottom Bar (even though hidden via CSS, keep synced)
    const stickyQtyEl = document.getElementById('ce-sticky-qty');
    const stickyPlacementEl = document.getElementById('ce-sticky-placement');
    const stickyTotalEl = document.getElementById('ce-sticky-total');

    if (stickyQtyEl) stickyQtyEl.textContent = `${totalCapsCount} item${totalCapsCount === 1 ? '' : 's'}`;
    if (stickyPlacementEl) stickyPlacementEl.textContent = activePlacement;
    if (stickyTotalEl) stickyTotalEl.textContent = `$${grandTotal.toFixed(2)}`;
  }

  // Initial calculation
  updateGlobalBulkInfo();
  buildOrderSummary();
  updateMultiPlacementContainer();

  /* ── 6. Checkout / Cart Dispatch (`Add Custom Order to Cart` & `Proceed Directly to Checkout`) ── */
  async function handleCheckoutAction(isDirectCheckout) {
    const bypassRadio = document.querySelector('input[name="ce_logo_bypass"]:checked');
    const bypassVal = bypassRadio ? bypassRadio.value : 'upload';
    
    let finalLogoText = activeDesignUrl || 'No logo provided';
    if (bypassVal === 'ordered_before') finalLogoText = 'Will use logo from previous order (Bypass)';
    if (bypassVal === 'email_later') finalLogoText = 'Will submit later via email (Bypass)';

    const itemsToAdd = [];
    let totalQty = 0;

    productCards.forEach(card => {
      const rows = card.querySelectorAll('.ce-variant-row');
      rows.forEach(row => {
        const inp = row.querySelector('.ce-qty-input');
        const qty = parseInt(inp ? inp.value : '0', 10);
        if (qty > 0) {
          const variant = getRowVariant(card, row);
          const variantId = variant ? variant.id : null;
          if (variantId) {
            totalQty += qty;
            const st = placementState[activePlacement] || {x:0, y:0, scale:1.0};
            const customScaleStr = st.scale !== 1.0 ? `, Scale: ${Math.round(st.scale * 100)}%` : '';
            const customPlacementStr = (st.x !== 0 || st.y !== 0 || customScaleStr) ? ` (Custom Offset X: ${st.x}px, Y: ${st.y}px${customScaleStr})` : '';
            const itemProps = {
                'Uploaded Logo': finalLogoText,
                'Embroidery Option': activeEmbStyle,
                'Placement': activePlacement + customPlacementStr,
                'Thread Colors': selectedThreadColors.join(', ') || 'Standard',
                'Color Notes': (colorNotesInp?.value || '').trim() || 'None',
                '_Design Type': activeDesignType,
                '_Tier Price': getTierPrice(totalQty, variant ? variant.price / 100 : 0).toFixed(2),
                '_Base Price': variant ? (variant.price / 100).toFixed(2) : '0.00'
            };

            const ownMaterialChk = document.getElementById('ce-own-material-chk');
            if (ownMaterialChk && ownMaterialChk.checked) {
              itemProps['Providing Own Material'] = 'Yes';
            }


            // Add any selected additional locations to the properties
            ['Back', 'Left Side', 'Right Side'].forEach(loc => {
              if (addLocData[loc] && addLocData[loc].checked) {
                const det = document.getElementById(`ce-text-${loc === 'Back' ? 'back' : loc === 'Left Side' ? 'left' : 'right'}`)?.value.trim() || 'None';
                const upload = addLocData[loc].url || 'No artwork uploaded';
                itemProps[`Add-On: ${loc} Stitching`] = `Details: ${det} | Artwork: ${upload}`;
              }
            });

            itemsToAdd.push({
              id: variantId,
              quantity: qty,
              properties: itemProps
            });
          }
        }
      });
    });

    if (itemsToAdd.length === 0) {
      alert('No products selected. Please select at least one item quantity in Step 1 above.');
      return;
    }

    if (bypassVal === 'upload' && (!activeDesignUrl || activeDesignUrl.trim() === '' || activeDesignUrl === 'No logo provided')) {
      alert('Please upload your custom embroidery logo design or select a saved design in Step 2 before proceeding.');
      const uploadStepEl = document.getElementById('ce-step-upload');
      if (uploadStepEl) {
        uploadStepEl.scrollIntoView({ behavior: 'smooth' });
      }
      return;
    }

    const activeBtn = isDirectCheckout ? document.getElementById('ce-direct-checkout-btn') : document.getElementById('ce-add-all-to-cart-btn');
    if (activeBtn) {
      activeBtn.disabled = true;
      const originalHtml = activeBtn.innerHTML;
      activeBtn.innerHTML = 'Generating Preview...';

              let mockupUrl = '';
        if (bypassVal === 'upload' && activeDesignUrl) {
          try {
            const h2c = await loadHtml2Canvas();
            let activeWrap = null;
            const mpContainer = document.getElementById('ce-multi-placement-container');
            if (mpContainer && mpContainer.style.display !== 'none') {
               activeWrap = mpContainer.querySelector('.ce-placement-card--active .ce-placement-img-wrap');
            }
            if (!activeWrap) {
               const defGrid = document.getElementById('ce-placement-grid');
               if (defGrid && defGrid.style.display !== 'none') {
                 activeWrap = defGrid.querySelector('.ce-placement-card--active .ce-placement-img-wrap');
               }
            }
            if (!activeWrap) {
               activeWrap = document.querySelector('.ce-placement-card--active .ce-placement-img-wrap');
            }
            
            if (activeWrap) {
              const canvas = document.createElement('canvas');
              canvas.width = activeWrap.offsetWidth || 500;
              canvas.height = activeWrap.offsetHeight || 500;
              const ctx = canvas.getContext('2d');
              
              ctx.fillStyle = '#f8fafc';
              ctx.fillRect(0, 0, canvas.width, canvas.height);
              
              const garmentImg = activeWrap.querySelector('.ce-mp-garment-img') || activeWrap.querySelector('.ce-placement-img');
              if (garmentImg && garmentImg.complete && garmentImg.naturalWidth) {
                const imgW = garmentImg.naturalWidth;
                const imgH = garmentImg.naturalHeight;
                const scale = Math.min(canvas.width / imgW, canvas.height / imgH) * 1.15;
                const drawW = imgW * scale;
                const drawH = imgH * scale;
                const drawX = (canvas.width - drawW) / 2;
                const drawY = (canvas.height - drawH) / 2;
                try { ctx.drawImage(garmentImg, drawX, drawY, drawW, drawH); } catch(e) {}
              }
              
              const logoImg = activeWrap.querySelector('.ce-logo-preview');
              if (logoImg && logoImg.style.display !== 'none' && logoImg.complete && logoImg.naturalWidth) {
                const wrapRect = activeWrap.getBoundingClientRect();
                const logoRect = logoImg.getBoundingClientRect();
                const imgW = logoImg.naturalWidth;
                const imgH = logoImg.naturalHeight;
                const scaleX = canvas.width / wrapRect.width;
                const scaleY = canvas.height / wrapRect.height;
                const dx = (logoRect.left - wrapRect.left) * scaleX;
                const dy = (logoRect.top - wrapRect.top) * scaleY;
                const dw = logoRect.width * scaleX;
                const dh = logoRect.height * scaleY;
                const rot = (placementState[activePlacement] && placementState[activePlacement].rotate) || 0;
                if (rot !== 0) {
                  ctx.save();
                  ctx.translate(dx + dw/2, dy + dh/2);
                  ctx.rotate(rot * Math.PI / 180);
                  try { ctx.drawImage(logoImg, -dw/2, -dh/2, dw, dh); } catch(e) {}
                  ctx.restore();
                } else {
                  try { ctx.drawImage(logoImg, dx, dy, dw, dh); } catch(e) {}
                }
              }
              
              const blob = await new Promise(res => canvas.toBlob(res, 'image/png'));
              if (blob) {
                const ucareInput = document.getElementById('ce-uploadcare-input');
                const pubKey = ucareInput ? (ucareInput.dataset.publicKey || '7c8d15c871b2c50cf320') : '7c8d15c871b2c50cf320';
                const fd = new FormData();
                fd.append('UPLOADCARE_PUB_KEY', pubKey);
                fd.append('UPLOADCARE_STORE', '1');
                fd.append('file', blob, 'mockup.png');
                const upRes = await fetch('https://upload.uploadcare.com/base/', { method: 'POST', body: fd });
                const upData = await upRes.json();
                if (upData && upData.file) {
                  let cdnBase = 'https://ucarecdn.com/';
                  if (activeDesignUrl) {
                    try { cdnBase = new URL(activeDesignUrl).origin + '/'; } catch(e) {}
                  }
                  mockupUrl = cdnBase + upData.file + '/';
                }
              }
            }
          } catch(e) { console.error(e); }
        }

        async function generateAddLocMockup(locName) {
          try {
            const card = Array.from(document.querySelectorAll('.ce-add-loc-card')).find(c => c.dataset.location === locName);
            if (!card) return null;
            const wrap = card.querySelector('.ce-placement-img-wrap');
            if (!wrap) return null;

            const canvas = document.createElement('canvas');
            canvas.width = wrap.offsetWidth || 400;
            canvas.height = wrap.offsetHeight || 400;
            const ctx = canvas.getContext('2d');
            
            ctx.fillStyle = '#f8fafc';
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            const garmentImg = wrap.querySelector('img:not(.ce-art-preview)');
            if (garmentImg && garmentImg.complete && garmentImg.naturalWidth) {
              const imgW = garmentImg.naturalWidth;
              const imgH = garmentImg.naturalHeight;
              const scale = Math.min(canvas.width / imgW, canvas.height / imgH);
              const drawW = imgW * scale;
              const drawH = imgH * scale;
              const drawX = (canvas.width - drawW) / 2;
              const drawY = (canvas.height - drawH) / 2;
              try { ctx.drawImage(garmentImg, drawX, drawY, drawW, drawH); } catch(e) {}
            }

            const logoImg = wrap.querySelector('.ce-art-preview');
            if (logoImg && logoImg.style.display !== 'none' && logoImg.complete && logoImg.naturalWidth) {
              const wrapRect = wrap.getBoundingClientRect();
              const logoRect = logoImg.getBoundingClientRect();
              
              const imgW = logoImg.naturalWidth;
              const imgH = logoImg.naturalHeight;
              const scale = Math.min(logoRect.width / imgW, logoRect.height / imgH);
              const drawW = imgW * scale;
              const drawH = imgH * scale;
              const offsetX = (logoRect.width - drawW) / 2;
              const offsetY = (logoRect.height - drawH) / 2;
              
              const finalX = (logoRect.left - wrapRect.left) + offsetX;
              const finalY = (logoRect.top - wrapRect.top) + offsetY;
              
              const rot = (placementState[locName] && placementState[locName].rotate) || 0;
              if (rot !== 0) {
                ctx.save();
                ctx.translate(finalX + drawW / 2, finalY + drawH / 2);
                ctx.rotate(rot * Math.PI / 180);
                try { ctx.drawImage(logoImg, -drawW / 2, -drawH / 2, drawW, drawH); } catch(e) {}
                ctx.restore();
              } else {
                try { ctx.drawImage(logoImg, finalX, finalY, drawW, drawH); } catch(e) {}
              }
            }

            const blob = await new Promise(res => canvas.toBlob(res, 'image/png'));
            if (!blob) return null;

            const ucareInput = document.getElementById('ce-uploadcare-input');
            const pubKey = ucareInput ? (ucareInput.dataset.publicKey || '7c8d15c871b2c50cf320') : '7c8d15c871b2c50cf320';
            const fd = new FormData();
            fd.append('UPLOADCARE_PUB_KEY', pubKey);
            fd.append('UPLOADCARE_STORE', '1');
            fd.append('file', blob, 'mockup-' + locName + '.png');
            
            const upRes = await fetch('https://upload.uploadcare.com/base/', { method: 'POST', body: fd });
            const upData = await upRes.json();
            if (upData && upData.file) {
              let cdnBase = 'https://ucarecdn.com/';
              if (addLocData[locName] && addLocData[locName].url) {
                try { cdnBase = new URL(addLocData[locName].url).origin + '/'; } catch(e) {}
              } else if (activeDesignUrl) {
                try { cdnBase = new URL(activeDesignUrl).origin + '/'; } catch(e) {}
              }
              return cdnBase + upData.file + '/';
            }
          } catch(e) { console.error(e); }
          return null;
        }

      if (mockupUrl) {
        itemsToAdd.forEach(item => {
          if (item.properties && item.properties['Uploaded Logo']) {
            item.properties['Mockup Preview'] = mockupUrl;
          }
        });
      }

      const activeAddLocs = ['Back', 'Left Side', 'Right Side'].filter(loc => addLocData[loc] && addLocData[loc].checked);
      if (activeAddLocs.length > 0) {
        const mockupTasks = activeAddLocs.map(loc => generateAddLocMockup(loc).then(url => ({ loc, url })));
        const mockupResults = await Promise.allSettled(mockupTasks);
        mockupResults.forEach(res => {
          if (res.status === 'fulfilled' && res.value.url) {
            itemsToAdd.forEach(item => {
              if (item.properties && !item.properties['_is_fee']) {
                item.properties[`Mockup - ${res.value.loc}`] = res.value.url;
              }
            });
          }
        });
      }

      activeBtn.innerHTML = isDirectCheckout ? 'Redirecting to Checkout...' : 'Adding to Cart...';

      try {
        const embId = parseInt(embroideryFeeId, 10);
        if (!isNaN(embId) && embId > 0 && embroideryFeePrice > 0) {
          itemsToAdd.push({
            id: embId,
            quantity: totalQty,
            properties: {
              '_is_fee': 'true',
              'Service': `Custom Embroidery Service ($${embroideryFeePrice.toFixed(2)}/cap)`
            }
          });
        }

        const addLocId = parseInt(addLocFeeId, 10);
        let extraLocs = 0;
        if (addLocData['Back'] && addLocData['Back'].checked) extraLocs++;
        if (addLocData['Left Side'] && addLocData['Left Side'].checked) extraLocs++;
        if (addLocData['Right Side'] && addLocData['Right Side'].checked) extraLocs++;

        if (!isNaN(addLocId) && addLocId > 0 && extraLocs > 0) {
          const addLocTotalInstances = extraLocs * totalQty;
          const addLocTierPrice = getAddLocTierPrice(addLocTotalInstances);
          itemsToAdd.push({
            id: addLocId,
            quantity: addLocTotalInstances,
            properties: {
              '_is_fee': 'true',
              'Service': `Additional Location Fee ($${addLocTierPrice.toFixed(2)}/location)`
            }
          });
        }

        const setupId = parseInt(setupFeeId, 10);
        // Only add setup fee when qty < 20, design is new, not high-DPI
        if (totalQty < 20 && !isNaN(setupId) && setupId > 0 && activeDesignType === 'new' && !activeDesignIsHighDpi) {
          const cartRes = await fetch('/cart.js').catch(() => ({ items: [] }));
          const cartData = cartRes.json ? await cartRes.json() : { items: [] };
          const alreadyHasFee = cartData.items && cartData.items.some(item => String(item.id) === String(setupId) || String(item.variant_id) === String(setupId));
          if (!alreadyHasFee) {
            itemsToAdd.push({
              id: setupId,
              quantity: 1,
              properties: {
                '_is_fee': 'true',
                'Service': `One-Time Digitizing Setup Fee ($${setupFeePrice.toFixed(2)} flat)`
              }
            });
          }
        }

        async function sendBatch(payload, isRetry = false) {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items: payload })
          });

          if (res.ok) {
            if (isDirectCheckout) {
              window.location.href = '/checkout';
            } else {
              window.location.href = '/cart';
            }
            return;
          }

          const errData = await res.json().catch(() => ({}));
          const errMsg = errData.description || errData.message || '';

          if (!isRetry) {
            const embFeeIdStr = String(embId || '');
            const setupFeeIdStr = String(setupId || '');
            const hasFeeItem = payload.some(it => String(it.id) === embFeeIdStr || String(it.id) === setupFeeIdStr);
            if (hasFeeItem) {
              console.warn('Fee variant not found or invalid in Shopify (`' + errMsg + '`). Retrying with apparel items only...');
              const hatOnly = payload.filter(it => String(it.id) !== embFeeIdStr && String(it.id) !== setupFeeIdStr);
              if (hatOnly.length > 0) {
                await sendBatch(hatOnly, true);
                return;
              }
            }
          }

          alert('Error adding items to cart: ' + (errMsg || 'Unknown error'));
          activeBtn.disabled = false;
          activeBtn.innerHTML = originalHtml;
        }

        await sendBatch(itemsToAdd);
      } catch (e) {
        console.error(e);
        alert('Network error while adding to cart. Please try again.');
        activeBtn.disabled = false;
        activeBtn.innerHTML = originalHtml;
      }
    }
  }

  const addAllBtn = document.getElementById('ce-add-all-to-cart-btn');
  const directCheckoutBtn = document.getElementById('ce-direct-checkout-btn');

  if (addAllBtn) {
    addAllBtn.addEventListener('click', () => handleCheckoutAction(false));
  }
  if (directCheckoutBtn) {
    directCheckoutBtn.addEventListener('click', () => handleCheckoutAction(true));
  }
});


